import CartHistoryModal from './CartHistoryModal';

export default CartHistoryModal;
